// const suppliers = (state = ['fabrication-offshore-gt-frfpcb'], action) => state;
const suppliers = (state = ['fabrication-offshore-gt-frfpcb']) => state;


export default suppliers;
